export default "__VITE_ASSET__BhI7H8nL__"